import setupLocatorUI from "@locator/runtime";
import { Toast, ToastProvider, globalToastDataState } from 'components/common/Toast/ErrorToast';
import { Toaster } from 'react-hot-toast';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { WinsRouter } from './router';

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}


const router = createBrowserRouter([{ path: '*', Component: WinsRouter }]);

function App() {
  const apiError = useRecoilValue(globalToastDataState);

  return (
    <ToastProvider swipeDirection='right'>
      <RouterProvider router={router} />
      {apiError && <Toast />}
      <Toaster />
    </ToastProvider>
  );
}

export default App;
